
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const Eventqueue = namespace("eventqueue");

@Component({
	components: {},
})
export default class ProcessingError extends Vue {
	@Eventqueue.Getter private getProcessingError: string;
	@Eventqueue.Mutation private setProcessingError: (error: string) => void;

	@Watch("getProcessingError", { immediate: true })
	private onProcessingErrorChange(value: string, oldValue: string) {
		if (value) {
			setTimeout(() => {
				this.setProcessingError(null);
			}, 5 * this.$config.ANIMATION_DURATION);
		}
	}
}
